import {getSession} from "next-auth/react";
import {isShowLinkInNavBar, myLinks, userHasPermissions} from "./myLinks";

export const adminAccess = async (context) => {
    const session = await getSession(context);

    if(!session){
        return {
            session: null,
            access: false,
            redirect: redirectIfNotAuth(context),
        }
    }

    const url = parseRoute(context.query, context.resolvedUrl)

    const route = myLinks.getByUrl(url)

    if (!userHasPermissions(route.permissions, session.user.permissions) || !isShowLinkInNavBar(route, session.user)){
        return {
            session: session,
            access: false,
            redirect: {
                notFound: true,
            },
        }
    }

    return {
        session,
        access: true
    }
}

export const userAccess = async (context) => {
    const session = await getSession(context);

    if(!session){
        return {
            session: null,
            access: false,
            redirect: redirectIfNotAuth(context),
        }
    }

    const url = parseRoute(context.query, context.resolvedUrl)

    const route = myLinks.getByUrl(url)

    if (!isShowLinkInNavBar(route, session.user)){
        return {
            session: session,
            access: false,
            redirect: {
                notFound: true,
            },
        }
    }

    return {
        session,
        access: true
    }
}

export const parseRoute = (query, resolvedUrl) =>{
    if (resolvedUrl.indexOf('?') > 0){
        resolvedUrl = resolvedUrl.substring( 0, resolvedUrl.indexOf('?'))
    }
    if (Object.keys(query).length){
        for (let key in query) {
            resolvedUrl = resolvedUrl.replace(query[key], `[${key}]`)
        }
    }

    return resolvedUrl
}

const redirectIfNotAuth = (context) => {
    const getRedirectLocaleUrl = () =>{
        const url = myLinks.getUlr('sign-in')

        if (!context){
            return url
        }

        if (context.locale === context.defaultLocale){
            return url
        }

        return `${context.locale}/${url}`
    }

    return {
        redirect: {
            permanent: false,
            destination: getRedirectLocaleUrl()
        }
    }
};
